import { get } from '../../json-transform';

// import { DEFAULT_LOGS_PAGE_SIZE } from 'helpers/constants';
export const DEFAULT_LOGS_PAGE_SIZE = 50;

export const paginationQSfields = {
  page: get('page').asInt().ifNaN(undefined),
  size: get('size', DEFAULT_LOGS_PAGE_SIZE).asInt().ifNaN(undefined),
};
